const handleInputNumberFormat = (inputObj) => {
  const { floatValue, formattedValue } = inputObj;
  if (formattedValue === '') return true;
  if (floatValue >= 1 && Number.isInteger(floatValue)) return true;
  return false;
};

export default handleInputNumberFormat;
